import React from 'react';

export const GoogleSVGIcon = () =>
  <svg className="google-svg-icon svg-icon" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M4.18601 9.99981C4.18601 9.35031 4.29551 8.72781 4.49201 8.14281L1.04951 5.57031C0.377512 6.90381 -0.000488281 8.40681 -0.000488281 9.99981C-0.000488281 11.5928 0.377512 13.0943 1.04801 14.4263L4.48901 11.8478C4.29401 11.2673 4.18601 10.6463 4.18601 9.99981Z" />
    <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M10.2325 4.09102C11.674 4.09102 12.976 4.59052 13.999 5.40802L16.9765 2.49952C15.1615 0.954524 12.8365 -0.000976562 10.2325 -0.000976562C6.1885 -0.000976562 2.713 2.26252 1.048 5.57002L4.492 8.14252C5.2855 5.78602 7.5475 4.09102 10.2325 4.09102Z" />
    <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M10.2325 15.9089C7.5475 15.9089 5.2855 14.2139 4.492 11.8574L1.048 14.4299C2.713 17.7374 6.1885 20.0009 10.2325 20.0009C12.7285 20.0009 15.1105 19.1339 16.8985 17.5079L13.63 15.0344C12.7075 15.6044 11.5465 15.9089 10.2325 15.9089Z" />
    <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M19.999 9.99964C19.999 9.40864 19.906 8.77264 19.7665 8.18164H10.2325V12.0456H15.7195C15.4465 13.3626 14.6995 14.3751 13.63 15.0336L16.8985 17.5071C18.778 15.8016 19.999 13.2591 19.999 9.99964Z" />
  </svg>

export const FacebookSVGIcon = () =>
  <svg className="facebook-svg-icon svg-icon" viewBox="0 0 10 20" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" d="M2.90449 20V11.054H0.000488281V7.49902H2.90449V4.69852C2.90449 1.65652 4.70749 -0.000976562 7.33999 -0.000976562C8.60149 -0.000976562 9.68599 0.0965234 9.99949 0.140023V3.32002H8.17399C6.74149 3.32002 6.46549 4.02352 6.46549 5.05102V7.49902H9.69649L9.25399 11.054H6.46549V20" />
  </svg>

export const LinkedInSVGIcon = () =>
  <svg className="linkedin-svg-icon svg-icon" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M4.07 17.15V5.58H0.23V17.15H4.07ZM2.15 4C3.49 4 4.33 3.11 4.33 2C4.3 0.86 3.49 0 2.18 0C0.87 0 0 0.86 0 2C0 3.11 0.83 4 2.12 4H2.15Z" />
    <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M6.20001 17.1498H10.05V10.6898C10.05 10.3398 10.07 9.9998 10.18 9.7498C10.46 9.0598 11.09 8.3398 12.15 8.3398C13.54 8.3398 14.1 9.3998 14.1 10.9598V17.1498H17.95V10.5098C17.95 6.9498 16.05 5.2998 13.52 5.2998C11.44 5.2998 10.53 6.4598 10.03 7.2498H10.06V5.5798H6.20001C6.25001 6.6598 6.20001 17.1498 6.20001 17.1498Z" />
  </svg>

export const XSVGIcon = () =>
  <svg className="x-svg-icon svg-icon" viewBox="0 0 1200 1227" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" />
  </svg>

export const MicrosoftSVGIcon = () =>
  <svg className="microsoft-svg-icon svg-icon" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" fillRule="evenodd" clipRule="evenodd" d="M15.9997 0H8.39989V7.59982H15.9997V0ZM15.9997 8.4H8.39989V15.9998H15.9997V8.4ZM0 8.4H7.59982V15.9998H0V8.4ZM7.59982 0H0V7.59982H7.59982V0Z" />
  </svg>

export const AppleSVGIcon = () =>
  <svg className="apple-svg-icon svg-icon" viewBox="0 0 22.773 22.773" xmlns="http://www.w3.org/2000/svg">
    <path className="fill" d="M15.769 0c.053 0 .106 0 .162 0 .13 1.606-.483 2.806-1.228 3.675-.731.863-1.732 1.7-3.351 1.573-.108-1.583.506-2.694 1.25-3.561C13.292.879 14.557.16 15.769 0z" />
    <path className="fill" d="M20.67 16.716c0 .016 0 .03 0 .045-.455 1.378-1.104 2.559-1.896 3.655-.723.995-1.609 2.334-3.191 2.334-1.367 0-2.275-.879-3.676-.903-1.482-.024-2.297.735-3.652.926-.155 0-.31 0-.462 0-.995-.144-1.798-.932-2.383-1.642-1.725-2.098-3.058-4.808-3.306-8.276 0-.34 0-.679 0-1.019.105-2.482 1.311-4.5 2.914-5.478.846-.52 2.009-.963 3.304-.765.555.086 1.122.276 1.619.464.471.181 1.06.502 1.618.485.378-.011.754-.208 1.135-.347 1.116-.403 2.21-.865 3.652-.648 1.733.262 2.963 1.032 3.723 2.22-1.466.933-2.625 2.339-2.427 4.74.176 2.181 1.444 3.457 3.058 4.139z" />
  </svg>

export const GoogleDriveSVGIcon = () => (
  <svg
    className="google-drive-svg-icon svg-icon"
    viewBox="0 0 27 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.03077 20.5692L3.21538 22.6154C3.46154 23.0461 3.81538 23.3846 4.23077 23.6308L8.46154 16.3077H0C0 16.7846 0.123077 17.2615 0.369231 17.6923L2.03077 20.5692Z"
      fill="#0066DA"
    />
    <path
      d="M13.4308 7.69216L9.2 0.36908C8.78462 0.615233 8.43077 0.953695 8.18462 1.38446L0.369231 14.9229C0.127604 15.3444 0.000321712 15.8217 0 16.3075H8.46154L13.4308 7.69216Z"
      fill="#00AC47"
    />
    <path
      d="M22.6308 23.6308C23.0462 23.3846 23.4 23.0461 23.6462 22.6154L24.1385 21.7692L26.4923 17.6923C26.7385 17.2615 26.8616 16.7846 26.8616 16.3077H18.3994L20.2 19.8461L22.6308 23.6308Z"
      fill="#EA4335"
    />
    <path
      d="M13.431 7.69231L17.6617 0.369231C17.2463 0.123077 16.7694 0 16.2771 0H10.5848C10.0925 0 9.61558 0.138462 9.2002 0.369231L13.431 7.69231Z"
      fill="#00832D"
    />
    <path
      d="M18.4002 16.3077H8.46173L4.23096 23.6308C4.64634 23.8769 5.12326 24 5.61557 24H21.2463C21.7387 24 22.2156 23.8615 22.631 23.6308L18.4002 16.3077Z"
      fill="#2684FC"
    />
    <path
      d="M22.5845 8.1537L18.6768 1.38446C18.4307 0.953695 18.0768 0.615233 17.6614 0.36908L13.4307 7.69216L18.3999 16.3075H26.846C26.846 15.8306 26.723 15.3537 26.4768 14.9229L22.5845 8.1537Z"
      fill="#FFBA00"
    />
  </svg>
);

export const ZoomSVGIcon = () => (
  <svg
    className="zoom-svg-icon svg-icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 0C18.6274 0 24 5.3726 24 12C24 18.6274 18.6274 24 12 24C5.3726 24 0 18.6274 0 12C0 5.3726 5.3726 0 12 0Z"
      fill="#4A8CFF"
    />
    <path
      d="M4.17114 8.24045V13.8798C4.17615 15.155 5.21771 16.1813 6.48793 16.1761H14.7081C14.9418 16.1761 15.1298 15.9881 15.1298 15.7595V10.1202C15.1248 8.84493 14.0832 7.81858 12.8132 7.82379H4.59301C4.35935 7.82379 4.17134 8.0118 4.17134 8.24045H4.17114ZM15.653 10.4403L19.0468 7.96114C19.3415 7.71727 19.5699 7.77814 19.5699 8.22023V15.7799C19.5699 16.2828 19.2904 16.222 19.0468 16.039L15.653 13.5648V10.4403Z"
      fill="white"
    />
  </svg>
);

export const OneDriveSVGIcon = () => (
  <svg
    className="onedrive-svg-icon svg-icon"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5222 12.4438V12.443L18.7653 15.5836L21.8894 14.2685C22.5244 13.9942 23.2089 13.8532 23.9006 13.8541C24.0161 13.8541 24.1301 13.8596 24.2433 13.8666C23.8678 12.4019 23.0749 11.0778 21.961 10.0552C20.8471 9.03266 19.4602 8.3557 17.9688 8.10662C16.4774 7.85754 14.9457 8.04707 13.56 8.65216C12.1743 9.25725 10.9941 10.2519 10.1631 11.5151L10.2427 11.5127C11.4013 11.5112 12.5372 11.8337 13.5222 12.4438V12.4438Z"
      fill="#0364B8"
    />
    <path
      d="M13.5231 12.443C12.5378 11.833 11.4016 11.5108 10.2428 11.5127L10.1632 11.515C9.02923 11.5292 7.92053 11.8521 6.95625 12.449C5.99197 13.046 5.20855 13.8943 4.69017 14.903C4.17179 15.9117 3.93804 17.0425 4.01403 18.1741C4.09002 19.3056 4.47289 20.3951 5.12149 21.3254L9.74334 19.3797L11.7991 18.5149L16.3749 16.5888L18.7646 15.5836L13.5231 12.443Z"
      fill="#0078D4"
    />
    <path
      d="M24.2436 13.8665C24.1296 13.8585 24.0153 13.8544 23.901 13.854C23.2095 13.8534 22.5253 13.9948 21.8906 14.2692L18.7656 15.5835L19.6717 16.1259L22.6414 17.9046L23.9369 18.6803L28.3676 21.3339C28.7701 20.5866 28.9788 19.7502 28.9743 18.9014C28.9699 18.0526 28.7526 17.2185 28.3422 16.4754C27.9319 15.7324 27.3416 15.1042 26.6256 14.6484C25.9095 14.1926 25.0905 13.9237 24.2436 13.8665V13.8665Z"
      fill="#1490DF"
    />
    <path
      d="M23.9369 18.6803L22.6413 17.9046L19.6717 16.1251L18.7664 15.5835L16.3758 16.5887L11.8 18.5149L9.74353 19.3796L5.12012 21.3253C5.69478 22.1514 6.46089 22.8262 7.35298 23.292C8.24508 23.7577 9.23666 24.0006 10.243 23.9999H23.901C24.8168 24.0003 25.7157 23.7526 26.5021 23.2832C27.2885 22.8138 27.9331 22.1402 28.3675 21.3339L23.9369 18.6803Z"
      fill="#28A8EA"
    />
  </svg>
);

export const ZoomPlaceholderSVGIcon = () => (
  <svg
    className="zoom-placeholder-svg-icon svg-icon"
    viewBox="0 0 40 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2134 1.3146C15.337 0.438201 14.191 0 13.0337 0C11.8876 0 10.7303 0.438201 9.85391 1.3146C8.10111 3.06741 8.10111 5.9101 9.85391 7.67414C11.6067 9.42695 14.4494 9.42695 16.2134 7.67414C17.9663 5.92134 17.9663 3.06741 16.2134 1.3146ZM14.9438 6.40448C13.8876 7.46066 12.1797 7.46066 11.1348 6.40448C10.0786 5.3483 10.0786 3.64044 11.1348 2.5955C12.191 1.53932 13.8988 1.53932 14.9438 2.5955C15.9887 3.64044 15.9887 5.3483 14.9438 6.40448Z"
      fill="#C0C0C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.6517 1.3146C24.7753 0.438201 23.6292 0 22.4719 0C21.3258 0 20.1685 0.438201 19.2921 1.3146C17.5393 3.06741 17.5393 5.9101 19.2921 7.67414C21.0449 9.42695 23.8876 9.42695 25.6517 7.67414C27.4045 5.92134 27.4045 3.06741 25.6517 1.3146ZM24.382 6.40448C23.3258 7.46066 21.618 7.46066 20.573 6.40448C19.5169 5.3483 19.5169 3.64044 20.573 2.5955C21.6292 1.53932 23.3371 1.53932 24.382 2.5955C25.427 3.64044 25.427 5.3483 24.382 6.40448Z"
      fill="#C0C0C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.79775 8.96627L2.24719 8.98874H8.98874L8.96627 8.53931C8.91009 7.79774 8.382 7.25841 7.64043 7.21347L7.191 7.191H3.14606L8.53931 1.79775L8.51684 1.34831C8.48313 0.60674 7.93257 0.0561793 7.191 0.0224715L6.74156 0H0L0.0224715 0.449437C0.0786512 1.17977 0.617976 1.73033 1.34831 1.77528L1.79775 1.79775H5.84268L0.449437 7.191L0.471909 7.64043C0.516852 8.382 1.05618 8.92133 1.79775 8.96627Z"
      fill="#C0C0C0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.5618 2.69662C32.7191 2.96629 32.7641 3.25842 32.7865 3.5955L32.809 4.04493V7.191L32.8315 7.64043C32.8764 8.37077 33.4158 8.92133 34.1573 8.96627L34.6068 8.98874V4.04493L34.6292 3.5955C34.6517 3.25842 34.6967 2.95505 34.854 2.68539C35.1686 2.14606 35.7416 1.79775 36.4045 1.79775C37.0674 1.79775 37.6517 2.1573 37.9663 2.69662C38.1236 2.96629 38.1686 3.26966 38.1798 3.5955L38.2023 4.04493V7.191L38.2247 7.64043C38.2697 8.382 38.809 8.92133 39.5506 8.96627L40 8.98874V4.04493V3.5955C40 1.60674 38.3933 0 36.4045 0C35.3259 0 34.3708 0.471909 33.7079 1.21348C33.045 0.471909 32.0899 0 31.0113 0C30.2697 0 29.5731 0.224719 29 0.617976C28.6517 0.224719 27.8652 0 27.4158 0V8.98874L27.8652 8.96627C28.618 8.92133 29.1573 8.382 29.191 7.64043L29.2135 7.191V4.04493L29.236 3.5955C29.2585 3.25842 29.3034 2.95505 29.4607 2.69662C29.7753 2.1573 30.3483 1.79775 31.0113 1.79775C31.6742 1.79775 32.2585 2.1573 32.5618 2.69662Z"
      fill="#C0C0C0"
    />
  </svg>
);


export const FacebookSquareSVGIcon = () => (
  <svg
    className="fb-square-svg-icon svg-icon"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z"
      fill="#1877F2"
    />
    <path
      d="M24 16C24 11.6 20.4 8 16 8C11.6 8 8 11.6 8 16C8 20 10.9 23.3 14.7 23.9V18.3H12.7V16H14.7V14.2C14.7 12.2 15.9 11.1 17.7 11.1C18.6 11.1 19.5 11.3 19.5 11.3V13.3H18.5C17.5 13.3 17.2 13.9 17.2 14.5V16H19.4L19 18.3H17.1V24C21.1 23.4 24 20 24 16Z"
      fill="white"
    />
  </svg>
);

export const TwitterSquareSVGIcon = () => (
  <svg className="twitter-square-svg-icon svg-icon"  width="1200" height="1227" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
  </svg>
);

export const LinkedInSquareSVGIcon = () => (
  <svg
    className="linkedin-square-svg-icon svg-icon"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z"
      fill="#2867B2"
    />
    <path
      d="M11.6 24H8.2V13.3H11.6V24ZM9.9 11.8C8.8 11.8 8 11 8 9.9C8 8.8 8.9 8 9.9 8C11 8 11.8 8.8 11.8 9.9C11.8 11 11 11.8 9.9 11.8ZM24 24H20.6V18.2C20.6 16.5 19.9 16 18.9 16C17.9 16 16.9 16.8 16.9 18.3V24H13.5V13.3H16.7V14.8C17 14.1 18.2 13 19.9 13C21.8 13 23.8 14.1 23.8 17.4V24H24Z"
      fill="white"
    />
  </svg>
);

export const WhatsappSquareSVGIcon = () => (
  <svg
    className="whatsapp-square-svg-icon svg-icon"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z"
      fill="#25D366"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6 10.3C20.1 8.8 18.1 8 16 8C11.6 8 8 11.6 8 16C8 17.4 8.40001 18.8 9.10001 20L8 24L12.2 22.9C13.4 23.5 14.7 23.9 16 23.9C20.4 23.9 24 20.3 24 15.9C24 13.8 23.1 11.8 21.6 10.3ZM16 22.6C14.8 22.6 13.6 22.3 12.6 21.7L12.4 21.6L9.89999 22.3L10.6 19.9L10.4 19.6C9.69999 18.5 9.39999 17.3 9.39999 16.1C9.39999 12.5 12.4 9.5 16 9.5C17.8 9.5 19.4 10.2 20.7 11.4C22 12.7 22.6 14.3 22.6 16.1C22.6 19.6 19.7 22.6 16 22.6ZM19.6 17.6C19.4 17.5 18.4 17 18.2 17C18 16.9 17.9 16.9 17.8 17.1C17.7 17.3 17.3 17.7 17.2 17.9C17.1 18 17 18 16.8 18C16.6 17.9 16 17.7 15.2 17C14.6 16.5 14.2 15.8 14.1 15.6C14 15.4 14.1 15.3 14.2 15.2C14.3 15.1 14.4 15 14.5 14.9C14.6 14.8 14.6 14.7 14.7 14.6C14.8 14.5 14.7 14.4 14.7 14.3C14.7 14.2 14.3 13.2 14.1 12.8C14 12.5 13.8 12.5 13.7 12.5C13.6 12.5 13.5 12.5 13.3 12.5C13.2 12.5 13 12.5 12.8 12.7C12.6 12.9 12.1 13.4 12.1 14.4C12.1 15.4 12.8 16.3 12.9 16.5C13 16.6 14.3 18.7 16.3 19.5C18 20.2 18.3 20 18.7 20C19.1 20 19.9 19.5 20 19.1C20.2 18.6 20.2 18.2 20.1 18.2C20 17.7 19.8 17.7 19.6 17.6Z"
      fill="white"
    />
  </svg>
);

export const TumblrSquareSVGIcon = () => (
  <svg
    className="tumblr-square-svg-icon svg-icon"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z"
      fill="#092345"
    />
    <path
      d="M17.3879 24C14.9774 24 13.1896 22.7646 13.1896 19.8016V15.0609H11V12.4896C13.4105 11.8669 14.4149 9.79787 14.5254 8H17.0264V12.0778H19.9391V15.0609H17.0264V19.189C17.0264 20.4244 17.6491 20.8562 18.6434 20.8562H20.0596V24H17.3879Z"
      fill="white"
    />
  </svg>
);

export const RedditSquareSVGIcon = () => (
  <svg
    className="reddit-square-svg-icon svg-icon"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27 0H5C2.23858 0 0 2.23858 0 5V27C0 29.7614 2.23858 32 5 32H27C29.7614 32 32 29.7614 32 27V5C32 2.23858 29.7614 0 27 0Z"
      fill="#FF3F18"
    />
    <path
      d="M24.9911 14.6125C25.0613 15.3783 24.7099 15.9464 24.1311 16.3848C23.9921 16.49 23.9491 16.5785 23.9737 16.7612C24.1551 18.1312 23.7646 19.332 22.883 20.365C21.7715 21.6672 20.3275 22.3781 18.706 22.7519C17.5793 23.0114 16.4387 23.0669 15.2917 22.9204C13.9805 22.7519 12.7299 22.3839 11.6025 21.6569C10.6148 21.0203 9.80154 20.2133 9.32886 19.097C8.99647 18.3119 8.91116 17.4959 9.04829 16.6546C9.06282 16.5643 9.04513 16.5145 8.96424 16.4597C8.47387 16.1239 8.11809 15.6817 8.02646 15.0703C7.79328 13.515 9.14687 12.5685 10.2869 12.8771C10.6167 12.9662 10.9219 13.1502 11.2347 13.2981C11.3112 13.3342 11.3624 13.3575 11.4458 13.2994C12.3602 12.6621 13.3656 12.2451 14.4468 12.0113C15.0497 11.8809 15.6576 11.7918 16.2744 11.7964C16.3963 11.797 16.4203 11.7299 16.4488 11.6369C16.7774 10.5671 17.1085 9.4986 17.4384 8.42945C17.5553 8.04983 17.7328 7.9433 18.1126 8.02659C19.027 8.22608 19.9414 8.42235 20.8545 8.62701C20.9677 8.65219 21.0321 8.63089 21.1079 8.5405C21.8833 7.6192 23.0865 8.04014 23.4739 8.74387C23.9579 9.62449 23.4157 10.724 22.4167 10.8886C21.69 11.0081 20.9702 10.5374 20.7768 9.79881C20.7357 9.64257 20.6637 9.59092 20.519 9.56058C19.8138 9.41402 19.1117 9.25455 18.409 9.10025C18.3534 9.08798 18.2965 9.08153 18.2257 9.06991C17.9313 10.0061 17.6399 10.9332 17.3404 11.8848C17.5173 11.9035 17.6715 11.9203 17.8257 11.9365C19.2027 12.0791 20.4798 12.5162 21.6388 13.2968C21.7121 13.3458 21.7557 13.3433 21.8271 13.2839C22.4521 12.7622 23.1491 12.6699 23.8777 12.9979C24.5507 13.3032 24.9222 13.8617 24.9911 14.6125ZM19.1224 17.614C19.7335 17.6134 20.277 17.0601 20.2744 16.4416C20.2719 15.7831 19.7493 15.2446 19.1161 15.2465C18.5013 15.2485 17.9654 15.7856 17.966 16.3983C17.9666 17.0685 18.4867 17.6147 19.1224 17.614ZM19.3954 19.8569C19.5281 19.7 19.494 19.5134 19.3721 19.3901C19.2027 19.2184 18.984 19.1706 18.8141 19.27C18.7458 19.3101 18.6833 19.3598 18.6163 19.4018C17.4453 20.1287 16.2219 20.2417 14.9543 19.7033C14.6945 19.5929 14.4557 19.4289 14.2111 19.2836C14.0291 19.1751 13.8004 19.2132 13.626 19.3934C13.5109 19.5115 13.4964 19.7149 13.6114 19.8814C13.6765 19.9751 13.7643 20.0596 13.8566 20.1255C14.649 20.6936 15.5401 20.9306 16.5707 20.9428C16.6826 20.9345 16.8658 20.9241 17.0491 20.9067C17.6899 20.8466 18.3009 20.6743 18.8539 20.3347C19.0555 20.2094 19.24 20.039 19.3954 19.8569ZM13.9198 17.614C14.4942 17.6127 15.0446 17.0368 15.0421 16.439C15.0396 15.7908 14.5069 15.2465 13.8762 15.2472C13.2537 15.2472 12.7236 15.7934 12.7248 16.4332C12.7267 17.0801 13.2683 17.6153 13.9198 17.614Z"
      fill="white"
    />
  </svg>
);
